<div ngModelGroup="comboTipoPublicoPrioritario-{{data}}" fxFlex="100" fxLayoutGap="20px">
    <combo-pesquisavel #comboTipoPublicoPrioritario
                       nome="tipoPublicoPrioritario-{{data}}"
                       [itens]="dados"
                       itemDescricao="descricao"
                       itemId="id"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Tipo Público Prioritário"
                       label="Tipo Público Prioritário"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
